<template>
	<div class="nav-bar">
		<div class="fixed-nav-bar">
			<div class="left-view" v-on:click="menuToggleChangeFun(true)">
				<span></span>
				<span></span>
				<span></span>
			</div>
			<img class="logo-img" src="images/logo.png" alt="">
		</div>
		<div class="menu-bg-view" v-on:click="menuToggleChangeFun(false)" v-show="showMenu"></div>
		<div class="menu-view" v-show="showMenu">
			<div class="header">
				<img class="logo-img" src="images/logo.png" alt="">
				<div class="close-view" v-on:click="menuToggleChangeFun(false)">
					<span></span>
					<span></span>
				</div>
			</div>
			<div class="section">
				<div :class="{item:true,active:item.active}" v-for="(item,index) in menuList" :key="item.pathName" @click="menuClickFun(index)">{{item.name}}</div>
				<div class="item" style="border: none;"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: "navMobile",
		props:{
			menuList: {
				type: Array,
				default(){
					return []
				}
			}
		},
		data (){
			return {
				showMenu: false
			}
		},methods:{
			menuToggleChangeFun (toggle){
				this.showMenu = toggle;
			},
			menuClickFun (index){
				this.$emit("menuchange",{
					current: this.$attrs,
					detail:{
						value: index
					}
				})
			}
		}
	}
</script>

<style scoped="scoped">
	.nav-bar,.fixed-nav-bar{
		width: 100%;
		height: 40px;
		background: #E0E0E0;
	}
	.fixed-nav-bar{
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.fixed-nav-bar>.left-view{
		width: 50px;
		height: 40px;
		flex-shrink: 0;
		padding: 0 16px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.fixed-nav-bar>.left-view>span{
		width: 100%;
		height: 2px;
		background: #4788F4;
		margin-top: 3px;
		flex-shrink: 0;
	}
	.fixed-nav-bar>.left-view>span:nth-of-type(1){
		margin-top: 0;
	}
	.fixed-nav-bar>.logo-img{
		width: 60px;
		margin-left: 28px;
		flex-shrink: 0;
	}
	.menu-bg-view{
		position: fixed;
		top: 0;
		left: 0;
		z-index: 100;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.65);
	}
	.menu-view{
		position: fixed;
		top: 0;
		left: 0;
		z-index: 101;
		width: 240px;
		height: 100%;
		background: #FFFFFF;
		box-shadow: 0 0 12px 0 rgba(0,0,0,0.2);
		display: flex;
		flex-direction: column;
	}
	.menu-view>.header{
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid #eeeeee;
		box-sizing: border-box;
		padding: 16px 0 0 12px;
	}
	.menu-view>.header>.logo-img{
		width: 70px;
		flex-shrink: 0;
	}
	.menu-view>.header>.close-view{
		width: 50px;
		height: 50px;
		flex-shrink: 0;
		position: relative;
	}
	.menu-view>.header>.close-view>span{
		width: 50%;
		height: 2px;
		background: #4788F4;
		position: absolute;
		top: 50%;
		left: 50%;
		transform-origin: center center;
		transform: translate(-50%, -50%) rotateZ(-45deg);
	}
	.menu-view>.header>.close-view>span:nth-of-type(1){
		transform: translate(-50%, -50%) rotateZ(45deg);
	}
	.menu-view>.section{
		width: 100%;
		height: 1px;
		flex: 1 1 auto;
		overflow: auto;
	}
	.menu-view>.section>.item{
		width: 100%;
		height: 48px;
		line-height: 48px;
		padding-left: 18px;
		box-sizing: border-box;
		font-size: 18px;
		font-family:Microsoft YaHei;
		font-weight:400;
		color: #333333;
		border-bottom: 1px solid #EEEEEE;
	}
	.menu-view>.section>.item.active{
		color: #4788F4;
	}
</style>
